import React, {useState} from "react";
import {axiosRun} from "../utils/axiosWrap";
import {config} from "../config";
import {UploadData} from "./UploadData";

export const UploadFacultety = ()=>{

    return <UploadData title={"оновлення факультетів студентів"} linkUpload={config.apiLinks.uploadUserFileFacultety} />
}